import { createTheme, makeStyles, responsiveFontSizes, ThemeProvider } from "@material-ui/core";
import { merge } from "lodash";
import React from "react";
import { useCongress } from "../hooks";
import overriddenTheme from "../theme";

const useStyles = makeStyles({
  root: {
    width: "100vw",
    height: "100vh",
    backgroundImage: ({ cover }) => `url(${cover})`,
    backgroundPositionX: "fixed",
    backgroundPositionY: "fixed",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    "-webkit-background-size": "cover",
    "-moz-background-size": "cover",
    "-o-background-size": "cover",
    backgroundSize: "cover"
  },
  loadingRoot: {
    width: "100vw",
    height: "100vh"
  }
});

const ConfigThemeProvider = ({ children }) => {
  const { congress } = useCongress();
  const classes = useStyles(congress);

  let theme = createTheme(
    merge(overriddenTheme, {
      palette: {
        type: congress.themeType,
        primary: {
          main: congress.highlightColor
        },
        text: {
          primary: congress.textColor
        },
        background: {
          default: congress.backgroundColor
        }
      },
      overrides: {
        MuiAppBar: {
          colorDefault: {
            color: congress.headerTextColor,
            backgroundColor: congress.headerColor
          }
        },
        MuiButton: {
          root: {
            color: "unset"
          }
        }
      }
    })
  );

  theme = responsiveFontSizes(theme, { factor: 3 });

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>{children}</div>
    </ThemeProvider>
  );
};

export default ConfigThemeProvider;
